// extracted by mini-css-extract-plugin
export default {"tableSummaryContainer":"TableSummary__tableSummaryContainer--E-t","accordionContainer":"TableSummary__accordionContainer--1Xm"};